export class VehicleDesignationModel {
    public vehicleDispositionText: string;
    public vehicleMakeCode: string;
    public itemModelYearDate: number;
    public brandDesignation: BrandDesignation;
    public reportingEntity: ReportingEntity;

}

export class BrandDesignation {
    public vehicleBrandCode: string;
    public vehicleBrandDate: Date;
    public vehicleBrandName: string;
    public reportingEntityName: string;
    public isRecognized: boolean;
    public nmvtisDisplayValue: string;
}

export class ReportingEntity {
    public contactEmailId: string;
    public entityName: string;
    public identificationId: string;
    public locationCityName: string;
    public locationPostalCode: string;
    public vehicleMakeCode: string;
}
